import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-wallet',
  templateUrl: './e-wallet.component.html',
  styleUrls: ['./e-wallet.component.css']
})
export class EWalletComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }
}
